export default "__VITE_ASSET__CTBGcwgp__"